// Module
var code = `<div class="center"> <h1 translate>common.cookiesRequired.WARNING</h1> <h4 translate>common.cookiesRequired.INSTRUCTIONS</h4> <div class="flex justify-center"> <a class="btn-flat bg-harvustorange text-white" ui-sref="signin" translate>common.cookiesRequired.CTA</a> </div> </div> `;
// Exports
export default code;